import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {OrderActionDisplayData} from "./order-action-display.data";

@Injectable()
export class OrderActionDisplayEntityModel extends EntityModel<OrderActionDisplayData> {
    constructor(injector: Injector) {
        super(injector, OrderActionDisplayData);
    }
}
